module.exports = __webpack_public_path__ + "img/house.62bc0387.png";